import {Box, Typography, Grid, useTheme, CircularProgress, IconButton, useMediaQuery, tooltipClasses, Tooltip} from '@mui/material';
import { mybiomatoken } from "../../../../constants";


export default function GutKitActivation() {

  const theme = useTheme()


const iframeUrl = `https://platform.mybioma.com/de/whitelabel/activate?token=${encodeURIComponent(mybiomatoken)}`;

return(

   <Grid container sx={{
       
        width: "100%", 
        display: "flex",
        justifyContent: "center",
        alignItems: "stretch", // stretch items vertically
      }}>

      <Grid size={12} sx={{width: '100vH', display: "flex", justifyContent: "center", alignItems:'flex-start',}}>
        
              <Typography variant="subtitle1" textAlign="center" sx={{mb:4, fontWeight: 400 }}>

                The stool collection kit for the gut microbiome test is on its way to you.<br />
                Activate the test kit with the 12-digit-number here. 

              </Typography>
 </Grid>

  <Grid size={12} sx={{flexGrow:1, display: "flex", height: "80vh", }}>
             
             
              <iframe
                    src={iframeUrl}
                    title="Third-party Secure Content"
                    style={{flexGrow: 1,width: "100%",height: "100%",  border: "none" }}
                    sandbox="allow-scripts allow-forms allow-same-origin"
                  />

        </Grid>

</Grid>


  );
}
